<template>
    <div class="login-img mx-sm-1 mt-9">
        <div class="page">
            <div class="">
                <!-- CONTAINER OPEN -->
                <div class="container">
                    <div class="row text-center mx-auto">
                        <div class="col-lg-8 col-sm-12 center-block align-items-center construction  ">
                            <div class="text-white">
                                <div class="card-body p-0">
                                    <div class="text-center mb-5">
                                        <img src="/img/logo_asin.png" class="header-brand-img" height="50" alt="LOGO ASIN">
                                    </div>
                                    <h1 class="display-4 mb-5 fw-semibold">En cours de développement...</h1>                                    
                                    <p>Cette page est en cours de développement ou en période de maintenance. Merci de bien vouloir patienter! </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- CONTAINER CLOSED -->
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>